"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = focusWithoutScrolling;

/**
 * IE and Edge browsers do not respect the `preventScroll` option when using `.focus()`. This
 * util allows similar a similar behavior.
 *
 * @param {HTMLElement} element
 */
function focusWithoutScrolling(element) {
  // @ts-ignore
  if (typeof element.setActive === 'function') {
    // @ts-ignore
    element.setActive();
  } else {
    element.focus({
      preventScroll: true
    });
  }
}